import "./i18n";
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";
import Quotation from "./pages/Quotation";
import QuotationRequest from "./pages/QuotationRequest";
import PaymentResult from "./pages/PaymentResult";


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Quotation />} />
        <Route path="/get_quote" element={<QuotationRequest />} />
        <Route path="/payment-result" element={<PaymentResult />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
